import React, {useState} from "react";
import { graphql, Link } from "gatsby";
import Img from "gatsby-image";
import CustomMarkdown from "../utils/customMarkdown"
import SEO from "../components/seo";
import Layout from "../components/layout";
import "../scss/events-page.scss";
import 'uikit/dist/css/uikit.css'
import GetImgUrl from "../utils/customFunctions";
import useSiteMetadata from "../utils/useSiteMetadata"
import { removeSlashFromSlug } from '../utils/additionalFunctions'; 
import loadable from '@loadable/component'

const QuoteCarousel = loadable(() => import("../components/quote-carousel"))
const VideoComponent = loadable(() => import("../components/video-component"))
const Tiles = loadable(() => import("../components/tiles"))
const Branches = loadable(() => import("../components/branches-component"))
const Hero = loadable(() => import("../components/basic-components/hero"))
const Paragraph = loadable(() => import("../components/paragraph"))
const StepsComponent = loadable(() => import("../components/steps-component"))
const FAQComponent = loadable(() => import("../components/faq-component"))
const SwirlComponent = loadable(() => import("../components/swirl-component"))
const Signup = loadable(() => import("../components/signup"))
const MapComponent = loadable(() => import("../components/map-component"))
const BranchLocator = loadable(() => import("../components/branch-locator"))
const InfiniteImageCarousel = loadable(() => import("../components/infinite-image-carousel"))
const InfiniteTextCarousel = loadable(() => import("../components/infinite-text-carousel"))

export const query = graphql`
  query eventsPagesQuery($id: Int) {
    strapiEvents(strapiId: { eq: $id }) {
      SEOTitle
      SEODescription
      Canonical
      MetaTags{
        MetaName
        MetaContent
      }
      Components
      Title
      slug
      Date
      Header {
        LeftBgColor
        RightBgColor
        Title
        Subtitle
        id
        CTA
        CTASecondary
        URL
        URLSecondary
        Visible
        Background {
          localFile {
            publicURL
            absolutePath
            childImageSharp {
              fluid(quality: 90, maxWidth: 1900) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        BottomMargin
      }
    }
  }
`;

const Events = ({ data }) => {
  var headerData = data.strapiEvents.Header != null ? {
    headerTitle: data.strapiEvents.Header.Title
      ? data.strapiEvents.Header.Title
      : "",
    headerDescription: data.strapiEvents.Header.Subtitle
      ? data.strapiEvents.Header.Subtitle
      : "",
    headerCTAPrimaryLabel: data.strapiEvents.Header.CTA
      ? data.strapiEvents.Header.CTA
      : "",
    headerCTAPrimaryUrl: data.strapiEvents.Header.URL
      ? data.strapiEvents.Header.URL
      : "",
    headerCTASecondaryLabel: data.strapiEvents.Header.CTASecondary
      ? data.strapiEvents.Header.CTASecondary
      : "",
    headerCTASecondaryUrl: data.strapiEvents.Header.URLSecondary
      ? data.strapiEvents.Header.URLSecondary
      : "",
    headerBgImage:
      data.strapiEvents.Header.Background.localFile.childImageSharp.fluid,
      headerRightBgColor: data.strapiEvents.Header.RightBgColor ? data.strapiEvents.Header.RightBgColor : '',
    headerLeftBgColor: data.strapiEvents.Header.LeftBgColor ? data.strapiEvents.Header.LeftBgColor : '',
    headerBottomMargin: data.strapiEvents.Header.BottomMargin != null ? data.strapiEvents.Header.BottomMargin : true,
  } : {};

  const { siteUrl: url } = useSiteMetadata();
  const pageHasHeader = data.strapiEvents.Header != null ? true : false; //check if Header is set
  const [headerParagraphSet, setHeaderParagraphSet] = useState(false);

  return (
    <div>
      <Layout
        pageData={headerData}
        headerShow={data.strapiEvents.Header != null ? data.strapiEvents.Header.Visible : false}
        eventDate={data.strapiEvents.Date}
        shareOnSocial={true}
      >
        <SEO title={data.strapiEvents.SEOTitle?data.strapiEvents.SEOTitle:(data.strapiEvents.Header != null? data.strapiEvents.Header.Title : "")} 
         description={data.strapiEvents.SEODescription} 
         meta={data.strapiEvents.MetaTags}
         canonical={data.strapiEvents.Canonical ? data.strapiEvents.Canonical : `${url + '/events/' + removeSlashFromSlug(data.strapiEvents.slug)}`}
         />
        <div className="events-page">
          {/* {data.strapiEvents.Components.map((item, index) => {
            return (
              <div key={index}>
              
                 <CustomMarkdown children={item.Text} /> 

                 {item.ImageCarousel?.Images ? (
                  <div className="event-page-image uk-height-medium uk-cover-container uk-margin-none">
                    <Img
                      fluid={
                        GetImgUrl(item.ImageCarousel.Images?.localFile___NODE)
                          .fluid
                      }
                      alt="image"
                    ></Img>
                  </div>
                ) : ""} 

                 {item.Links ? (
                  <Link to={item.Links.URL} className="event-page-link">
                    {item.Links.Link}
                  </Link>
                ) : ""} 

                 {item.Testimonial 
                  ? (<div className="">
                      <QuoteCarousel quoteList={item.Testimonial}></QuoteCarousel>
                    </div>
                    ) 
                  : (
                    ""
                  )} 
              </div>
            );
          })} */}
          {data.strapiEvents.Components.map((item, index) => {
            switch (item.strapi_component) {
              case "basic-components.paragraph":
                var forceH1Title = false;
                var overlaySwirl = false;
                var overlaySubstractTransform = true;

                if((pageHasHeader == false && headerParagraphSet == false) || item.IsHeader == true){
                  setHeaderParagraphSet(true);
                  forceH1Title = true;
                }

                if(index == 0 && item.TopSwirl == true){ //if paragraph is the first item in pageComponents and has topSwirl then overlay the header image
                  overlaySwirl = true;
                }
                if(data.strapiEvents.Header.BottomMargin == false){
                  overlaySubstractTransform = false;
                }
                return (               
                    <Paragraph
                        key={index}
                        title={item.Title}
                        text={item.Text}
                        image={item.Image}
                        imagePosition={item.ImagePosition}
                        bgColor={item.BackgroundColor || ""}
                        topPadding={(item.TopPadding === true) ? true : false}
                        bottomPadding={(item.BottomPadding === true) ? true : false}
                        forceH1Title={forceH1Title}
                        alignment={item.ContentAlignment}
                        initialPadding={item.InitialPadding}
                        topSwirl={item.TopSwirl}
                        bottomSwirl={item.BottomSwirl}
                        bottomMargin={item.BottomMargin}
                        overlaySwirl={overlaySwirl}
                        leftPadding={item.LeftPadding}
                        rightPadding={item.RightPadding}
                        overlaySubstractTransform={overlaySubstractTransform}
                    ></Paragraph>
                )
              case "basic-components.hero-section":
                return(
                  <Hero
                    title={item.Hero.Title}
                    description={item.Hero.Description}
                    label={item.Hero.Label}
                    url={item.Hero.url}
                    key={index}
                    sectionStyle = "white"
                  ></Hero>
                )
              case "basic-components.branches-component":
                const branchesBgColor = item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'dark'; 
                return(
                  <Branches key={index} branchList={item.BranchesList} title={item.Title} sectionStyle={branchesBgColor} />
                )
              case "basic-components.video-section":
                return(
                  <VideoComponent key={index} src={item.YoutubeURL}/>
                )
              case "basic-components.testimonial-section":
                return(
                    <div key={index} className="">
                      <QuoteCarousel quoteList={item.Testimonial}></QuoteCarousel>
                    </div>
                )
              case "cta.cta-section":
                const sectionBgColor = item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'dark'; 
                const fullWidthSectionBgColo =  item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'white'; 
                return(
                  <div key={index}>
                    {item.CTA !== undefined && item.CTA.length > 1 ? (<Tiles data={item.CTA} width='half' key={index} sectionStyle={sectionBgColor}></Tiles>) : ("")}

                    {item.CTA !== undefined && item.CTA.length === 1 ? (<Tiles data={item.CTA} key={index} singleFlag={true} width='full' sectionStyle={fullWidthSectionBgColo}></Tiles>) : ("")
                      // (item.CTA !== null && Object.keys(item.CTA).length === 1)?<Tiles data={item.CTA} singleFlag={true}></Tiles>:""
                      //don't forget to fix this once the cta.length of a json (dynamic zone) is found
                    }
                  </div>
                )
              case "basic-components.text-section":
                return (               
                  item.Text ? (
                    <>
                      <CustomMarkdown key={index} children={item.Text} />
                          {item.Links 
                            ?<Link to={item.Links.URL} className="event-page-link">
                              {item.Links.Link}
                            </Link>  
                            : ''}
                    </>
                  ) : (
                    ""
                  )
                )
              case "basic-components.image-carousel":
                return (               
                  item.Images 
                    ? ( <div key={index} className="image_wrap">
                      <div className="image-section uk-cover-container uk-margin-none">
                        {/* <img src={item.Images.publicURL} alt="" data-uk-cover/> */}
                        <Img
                          // fluid={item.Images.childImageSharp.fluid}
                          fluid={GetImgUrl(item.Images.localFile___NODE).fluid}
                          alt={"image"}
                          data-uk-cover
                        ></Img>
                      </div>
                    </div>
                    ) 
                    : ("")
                )
              case "basic-components.image-carousel-section":
                return(
                  item.ImageCarousel?.Images ? (
                    <div className="event-page-image uk-height-medium uk-cover-container uk-margin-none">
                      <Img
                        fluid={
                          GetImgUrl(item.ImageCarousel.Images?.localFile___NODE)
                            .fluid
                        }
                        alt="image"
                      ></Img>
                    </div>
                  ) : ""
                )
              case "basic-components.steps-component":
                return(
                  <StepsComponent key={index} stepsList={item.StepsList} sectionStyle="white" />
                )
              case "basic-components.faq-component":
                return(
                  <FAQComponent key={index} faqList={item.FAQList} sectionStyle="white" />
                )             
              case "basic-components.signup-component":
                return(
                  <Signup
                    title="Sign Up to Our Newsletter"
                    description="Get updates on all the lastest information, or stay informed about our courses"
                    buttonLabel="Sign Up"
                    sectionStyle = "white"
                  />
                )
              case "basic-components.swirl-component":                
                return(
                  <SwirlComponent 
                    key={index} 
                    bgColor={item.SwirlColor} topSwirl={item.Position == "Top" ? true : false} 
                    />
                )
              case "basic-components.map-component":                
                return(
                  <MapComponent 
                    key={index} 
                    title={item.Title}
                    gMapsLocation={item.GMapsLocation} 
                    />
                )
              case "basic-components.branch-locator":                
                return(
                  <BranchLocator 
                    key={index} 
                    title={item.Title}
                    subtitle={item.Subtitle}
                    branchesList={item.Branches} 
                    />
                )
              case "basic-components.infinite-image-carousel":                
                return(
                  <InfiniteImageCarousel 
                    key={index} 
                    title={item.Title}
                    imageList={item.LinkImageList} 
                    backgroundColor={item.BackgroundColor}
                    />
                )
              case "basic-components.infinite-text-carousel":                
                return(
                  <InfiniteTextCarousel 
                    key={index} 
                    title={item.Title}
                    textList={item.LinkTextList} 
                    backgroundColor={item.BackgroundColor}
                    />
                )
              default:
                return ('')
          }
        }
        )} 

        </div>
      </Layout>
    </div>
  );
};

export default Events;
